export default function Crest({ className = "h-9 w-9" }) {
  return (
    <svg viewBox="0 0 64 72" className={className} fill="none" aria-hidden="true">
      <path d="M32 3l26 9v22c0 17-10.5 28.5-26 35C16.5 62.5 6 51 6 34V12z" stroke="#D4AF37" strokeWidth="2.5" fill="rgba(212,175,55,0.08)" />
      <path d="M32 14l16 5.5V34c0 11-6.7 18.4-16 22.6C22.7 52.4 16 45 16 34V19.5z" fill="rgba(212,175,55,0.14)" />
      <text x="32" y="44" textAnchor="middle" fontFamily="Cinzel, Georgia, serif" fontWeight="700" fontSize="19" fill="#D4AF37">91</text>
    </svg>
  );
}
